// src/pages/helppage.js
import React from 'react';
import '../components/helppage.css'; // Optional, if you want to style this

export default function HelpPage() {
  return (
    <div className="help-page">
      <h2>Need Help?</h2>
      <p>
        For assistance, please email us at{' '}
        <a href="mailto:support@yourdomain.com">info@screentoscene.com</a>
      </p>
    </div>
  );
}
